import React from "react";
import ReactDOM from "react-dom/client";
import IndexRouter from "./router/IndexRouter";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { HelmetProvider } from "react-helmet-async";
import "./lang/i18n";

import theme from "./theme/theme";
import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data freshness: Queries won't refetch for 5 minutes unless explicitly invalidated
      staleTime: 5 * 60 * 1000,

      // Cached data retention: Keeps data in memory for 10 minutes
      cacheTime: 10 * 60 * 1000,

      // Automatically retry failed queries 2 times
      retry: 3,

      // Automatically refetch on window focus
      refetchOnWindowFocus: true,

      // Enable background updates for queries with data already in the cache
      refetchOnMount: false,
      refetchInterval: false,
    },
    mutations: {
      // Retry failed mutations once
      retry: 3,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <HelmetProvider>
          <CartProvider>
            <AuthProvider>
              <IndexRouter />
            </AuthProvider>
          </CartProvider>
        </HelmetProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
